export * from './ActorQueryResultSerializeSimple';
